import { useCallback, useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { PolicyDocumentItem, policiesApi } from "./api";
import PoliciesHome from "./PoliciesHome";
import PolicyDocumentDetail from "./PolicyDocumentDetail";

// /policies: the department's policy documents and a chat over them, for
// officers who belong to an agency. Solo officers see an explanation.
const PoliciesRouter: React.FC = () => {
  const { user } = useAuth();
  const [agencyName, setAgencyName] = useState("");
  const [documents, setDocuments] = useState<PolicyDocumentItem[]>([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const data = await policiesApi.list();
      setAgencyName(data.agencyName);
      setDocuments(data.documents);
    } catch {
      setDocuments([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (user?.agency_id) load();
    else setLoading(false);
  }, [user?.agency_id, load]);

  if (user && !user.agency_id) {
    return (
      <div className="flex-1 flex items-center justify-center p-8">
        <div className="max-w-md text-center">
          <h1 className="text-xl font-bold text-base-content">Policies</h1>
          <p className="mt-2 text-sm text-base-content/70">Department policies are available to officers whose agency uses Police Narratives AI. Your agency's admin uploads the policy manual and local ordinances, and your reports cite them automatically.</p>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      <Route index element={<Navigate to="documents" replace />} />
      <Route path="documents/:documentId" element={<PolicyDocumentDetail agencyName={agencyName} />} />
      <Route path="chat/:threadId" element={<PoliciesHome agencyName={agencyName} documents={documents} loading={loading} />} />
      <Route path=":tab" element={<PoliciesHome agencyName={agencyName} documents={documents} loading={loading} />} />
    </Routes>
  );
};

export default PoliciesRouter;
